<div class="metadataLabel" [ngClass]="{'forge-typography--body1': compact, 'dense-input': dense}" [style.fontWeight]="fontWeight" focusOnLoad>
    <p style="white-space:pre-wrap;">{{ label }}</p>
</div>
